import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { CenterFlex, Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { radius } from '@/styles/sizes';
import { animation } from '@/styles/style';

type Props = {
  name: string;
  prompt?: string;
  shares?: number;
  onDeleteClick?: (text: string) => void;
};

const AddedItem = (props: Props) => {
  return (
    <SelectItemStyle>
      <Typo type="label2" style={{ transition: 'all 0.2s' }}>
        {props.name}
      </Typo>
      {props.shares && (
        <Typo type="label3" weight="r">
          {props.shares.toFixed(1)}%
        </Typo>
      )}
      <DeleteIconWrapper onClick={() => props.onDeleteClick?.(props.name)}>
        <CloseOutlined />
      </DeleteIconWrapper>
    </SelectItemStyle>
  );
};

const DeleteIconWrapper = styled(CenterFlex)`
  background-color: ${(props) => props.theme.colors.FL100};
  color: ${(props) => props.theme.colors.FD60};
  padding: 4px;
  border-radius: ${radius.token['3xl']}px;
  cursor: pointer;
  font-size: 12px;
`;

const SelectItemStyle = styled(Flex)`
  width: fit-content;
  align-items: center;
  color: ${(props) => props.theme.colors.FL100};
  gap: 8px;
  padding: 6px 9px 6px 13px;
  background-color: ${(props) => props.theme.colors.primary100};
  border-radius: ${radius.token['4xl']}px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
  &:hover {
    filter: brightness(1.05);
  }
  animation: ${animation.scaleIn} 0.4s both;
`;

export default AddedItem;
